import _defineProperty from "babel-runtime/helpers/defineProperty";
import _extends from "babel-runtime/helpers/extends";
import React from "react";
import firebase from "firebase/app";
import "firebase/firestore";

var _React$createContext = React.createContext(null),
    FirebaseAppProvider = _React$createContext.Provider,
    FirebaseAppConsumer = _React$createContext.Consumer;

export { FirebaseAppProvider, FirebaseAppConsumer };


export function withFirebaseApp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var opts = _extends({
    propName: "firebaseApp"
  }, options);
  return function (Component) {
    return function WithFirebaseApp(initialProps) {
      return React.createElement(
        FirebaseAppConsumer,
        null,
        function (app) {
          var _extends2;

          var props = _extends((_extends2 = {}, _defineProperty(_extends2, opts.propName, app), _defineProperty(_extends2, "firebase", firebase), _extends2), initialProps);
          return React.createElement(Component, props);
        }
      );
    };
  };
}

export function init(config) {
  var fb = firebase.initializeApp(config);
  var firestore = firebase.firestore();
  var settings = { timestampsInSnapshots: true };
  firestore.settings(settings);
  return fb;
}
//# sourceMappingURL=firebase.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/util/firebase.js
// module id = 98
// module chunks = 0